module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1038-048c42c3d8bb3a617177c1812947e292.png";